<template>
    <div class="flex items-center gap-2 cursor-pointer" @click="like">
        <ion-icon
            name="trophy"
            class="text-xl"
            :style="{
                color: 'rgb(228 179 30)',
            }"
            v-if="state.isLiked"
        ></ion-icon>
        <ion-icon name="trophy-outline" class="text-xl" v-else></ion-icon>
        <span class="text-gray-400">{{ formattedLikes }}</span>
    </div>
</template>
<script setup>
import { defineProps, reactive, computed } from "vue";

const props = defineProps({
    postId: {
        type: Number,
        required: true,
    },
    likes: {
        type: Number,
        default: 0,
    },
    isLiked: {
        type: Boolean,
        default: false,
    },
});

const formattedLikes = computed(() => {
    //format to 1k, 10k, and soon
    if (state.likes >= 1000 && state.likes < 1000000) {
        return (state.likes / 1000).toFixed(1).replace(/\.0$/, "") + "k";
    } else if (state.likes >= 1000000) {
        return (state.likes / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
    }
    return state.likes;
});

const state = reactive({
    likes: props.likes,
    isLiked: props.isLiked,
});

async function like() {
    const resp = await axios.post(`/new-forum/posts/${props.postId}/like`);
    state.likes = resp.data.likes;
    state.isLiked = resp.data.isLiked;
}
</script>
